/// <amd-module name="Artifacts/Npm/components/Logo" />

import * as NpmRes from "Artifacts/Npm/Resources";
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-npm.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={NpmRes.Logo_Npm}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-npm/img/npm.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
